import validatorRegistry from "./validatorRegistry";

function checkEmpty(value) {
  return (!value.toString().trim()) ? "Field cannot be empty" : null;
}

function checkSocRange(value) {
  const num = parseFloat(value);
  if (num < 0 || num > 100) return "Must be between 0 and 100";
  return null;
}

function validateField(name, value) {
  const validator = validatorRegistry[name];
  return validator(value);
}

export {
  checkEmpty,
  checkSocRange
};

export default validateField;
